var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { injectIntl, FormattedDate, FormattedMessage } from "@irati/utils/lang";
import customRewardImage from "@irati-web/reward/src/images/customReward.png";
import StockType from "@irati/stock/enums/StockType";
import CopyButton from "./CopyButton";
import PopUpHeader from "./PopUpHeader";
import ValueLabel from "./ValueLabel";
import Code from "./Code";
import { StyledModal, CustomCreditInstructions } from "./styled";
var MyRewardPopup = /** @class */ (function (_super) {
    __extends(MyRewardPopup, _super);
    function MyRewardPopup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyRewardPopup.prototype.render = function () {
        var _a = this.props, show = _a.show, onHide = _a.onHide, redemption = _a.redemption, formatMessage = _a.formatMessage;
        if (!redemption)
            return null;
        var rewardOrder = redemption.rewardOrder, custom = redemption.custom;
        var reward = rewardOrder.reward, product = rewardOrder.product, createdBy = rewardOrder.createdBy;
        var rewardStockExists = reward && redemption.stock && product;
        return (React.createElement(StyledModal, { show: show, onHide: onHide },
            rewardStockExists && (React.createElement(PopUpHeader, { title: reward.header, subtitle: product.name, thumbnailImage: reward.thumbnailImage, instructions: reward.redemptionInstructions, termsAndConditions: reward.termsAndConditions, message: rewardOrder.message })),
            custom && React.createElement(PopUpHeader, { title: custom, thumbnailImage: customRewardImage, message: rewardOrder.message }),
            reward && reward.isCredit && (React.createElement(PopUpHeader, { title: reward.header, subtitle: product.name, thumbnailImage: reward.thumbnailImage, message: rewardOrder.message })),
            rewardStockExists && React.createElement(Code, { redemption: redemption }),
            !rewardStockExists && custom && (React.createElement(CustomCreditInstructions, null,
                React.createElement(FormattedMessage, { id: "recognition.account.rewards.customInstructions", values: { firstName: createdBy.firstname, lastName: createdBy.lastname } }))),
            reward && reward.isCredit && (React.createElement(CustomCreditInstructions, null,
                React.createElement(FormattedMessage, { id: "recognition.account.rewards.creditInstructions" }))),
            rewardStockExists && redemption.stock.expiry && (React.createElement(ValueLabel, { date: React.createElement(FormattedDate, { year: "numeric", month: "short", day: "2-digit", value: redemption.stock.expiry }), label: formatMessage({ id: "recognition.account.rewards.expiryDate" }) })),
            rewardStockExists && redemption.stock.pin && (React.createElement(ValueLabel, { value: redemption.stock.pin, label: formatMessage({ id: "recognition.account.rewards.pin" }) })),
            rewardStockExists && redemption.stock.type === StockType.TEXT && (React.createElement(CopyButton, { text: formatMessage({ id: "recognition.account.rewards.copyCode" }), redemptionCode: redemption.stock.code }))));
    };
    return MyRewardPopup;
}(PureComponent));
export default injectIntl(MyRewardPopup);
